var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.64767 13.507C9.50123 13.3605 9.50123 13.1231 9.64767 12.9766L12.8743 9.74998H2.625C2.41789 9.74998 2.25 9.58209 2.25 9.37498V8.62498C2.25 8.41787 2.41789 8.24998 2.625 8.24998H12.876L9.64768 5.02168C9.50123 4.87523 9.50123 4.63779 9.64768 4.49135L10.178 3.96102C10.3245 3.81457 10.5619 3.81457 10.7083 3.96102L15.4813 8.73399C15.6277 8.88044 15.6277 9.11787 15.4813 9.26432L10.7083 14.0373C10.5619 14.1837 10.3244 14.1837 10.178 14.0373L9.64767 13.507Z","fill":"#464A51"}));
}

Icon.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = Icon;

Icon.default = Icon;
